import React from 'react';
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { useAuth } from '../contexts/AuthContext';
import { MailIcon } from './Icons';
import '../styles/Contact.css';
import rekhamaam from '../assets/rekhamaam.jpg';
import abhilashsir from '../assets/abhilashsir.png';
import avatar5 from '../assets/avatar5.png';

interface TeamMember {
  name: string;
  role: string;
  email: string;
  image: string;
}

const Contact: React.FC = () => {
  const navigate = useNavigate();
  const { user } = useAuth();

  const teamMembers: TeamMember[] = [
    {
      name: 'Rekha',
      role: 'Dean Jssateb',
      email: 'rekha@nexus.org',
      image: rekhamaam
    },
    {
      name: 'Abhilash',
      role: 'Assistant professor',
      email: 'abhilash@nexus.org',
      image: abhilashsir
    },
  ];

  const handleBack = () => {
    if (user?.role) {
      const normalizedRole = user.role.toUpperCase().replace('-', '_');
      if (normalizedRole === 'STUDENT') {
        navigate('/dashboard/student');
      } else {
        navigate('/');
      }
    } else {
      navigate('/');
    }
  };

  return (
    <motion.div 
      initial={{ opacity: 0 }} 
      animate={{ opacity: 1 }}
      className="contact-page"
    >
      <button className="back-button" onClick={handleBack}>
        ← BACK
      </button>

      <div className="contact-header">
        <h1 className="contact-title">CONTACT US</h1>
        <p className="contact-subtitle">Meet Our Team</p>
      </div>

      <div className="team-grid">
        {teamMembers.map((member, index) => (
          <motion.div
            key={member.email}
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: index * 0.1 }}
            className="team-card"
          >
            <div className="card-border-glow"></div>
            
            <div className="team-card-inner">
              <div className="team-image-container">
                <img 
                  src={member.image} 
                  alt={member.name}
                  className="team-image"
                  onError={(e) => {
                    (e.target as HTMLImageElement).src = avatar5;
                  }}
                />
                <div className="image-overlay"></div>
              </div>

              <div className="team-info">
                <h3 className="team-name">{member.name}</h3>
                <p className="team-role">{member.role}</p>
                
                <div className="team-contact">
                  <div className="contact-item">
                    <span className="contact-icon"><MailIcon size={16} color="#00ffff" /></span>
                    <a href={`mailto:${member.email}`} className="contact-link">
                      {member.email}
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </motion.div>
        ))}
      </div>
    </motion.div>
  );
};

export default Contact;
